import React from "react";
import { FiChevronRight, FiLock, FiShield } from "react-icons/fi";
import SettingsHeader from "./SettingsHeader";

const LockIcon = FiLock;
const ShieldIcon = FiShield;
const ChevronIcon = FiChevronRight;

const SecurityRow = ({ icon: Icon, title, subtitle, meta, danger = false, onClick }) => (
  <button
    type="button"
    className={`pp-settings-row pp-settings-menu-row pp-settings-security-row ${danger ? "is-danger" : ""}`}
    onClick={onClick}
  >
    <span className="pp-settings-row-icon pp-settings-menu-icon" aria-hidden="true">
      <Icon />
    </span>
    <span className="pp-settings-row-copy pp-settings-menu-copy">
      <span className="pp-settings-row-title pp-settings-menu-title">{title}</span>
      {subtitle && <span className="pp-settings-row-subtitle pp-settings-menu-subtitle">{subtitle}</span>}
      {meta && <span className={`pp-settings-security-meta ${danger ? "is-danger" : ""}`}>{meta}</span>}
    </span>
    <ChevronIcon className="pp-settings-row-chevron pp-settings-menu-chevron" aria-hidden="true" />
  </button>
);

export default function SecuritySettingsScreen({ t, onBack, onOpenPassword }) {
  return (
    <div className="pp-settings-screen pp-settings-subscreen pp-settings-security-screen">
      <SettingsHeader
        t={t}
        title={t("parentPortal.settings.security", { defaultValue: "Security" })}
        subtitle={t("parentPortal.settings.security_page_subtitle", { defaultValue: "Manage your password and security" })}
        onBack={onBack}
      />

      <section className="pp-settings-card pp-settings-security-card">
        <SecurityRow
          icon={LockIcon}
          title={t("parentPortal.settings.change_password", { defaultValue: "Change password" })}
          subtitle={t("parentPortal.settings.change_password_subtitle", { defaultValue: "Choose a strong password" })}
          onClick={onOpenPassword}
        />
        <SecurityRow
          icon={ShieldIcon}
          title={t("parentPortal.settings.two_step", { defaultValue: "Two-step verification" })}
          subtitle={t("parentPortal.settings.two_step_subtitle", { defaultValue: "Extra security for your account" })}
          meta={t("common.disabled", { defaultValue: "Disabled" })}
          danger
          onClick={() => {}}
        />
      </section>
    </div>
  );
}
